import { render, staticRenderFns } from "./Tab6.vue?vue&type=template&id=ddac2ef4&scoped=true&"
import script from "./Tab6.vue?vue&type=script&lang=ts&"
export * from "./Tab6.vue?vue&type=script&lang=ts&"
import style0 from "./Tab6.vue?vue&type=style&index=0&id=ddac2ef4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddac2ef4",
  null
  
)

export default component.exports